import React from "react";
import PropTypes from 'prop-types';
import { NavLink as RouterLink, Link } from "react-router-dom";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Popover from "../PopOver/Popover";
import Notification from "./Notification/Notification";
import notification from "../../../images/notification.png";
import others from "../../../images/new-images/others.png";
import userIcon from "../../../images/new-images/user-icon .png";
import femaleIcon from "../../../images/new-images/female-user.png";
import opptimiseLogo from "../../../images/new-images/Brand-Logo.png";
import "./NavBar.css";

const NewNavBar = (props) => {

  const calcWidth = window.innerWidth;

  const logout = () => localStorage.clear();

  const userName =
    localStorage.getItem("user_name") === "null"
      ? "-"
      : localStorage.getItem("user_name");
  const genderName = localStorage.getItem("Gender");

  const handleGender = () => {
    if (genderName == "1") {
      return <img className="userIcon" src={userIcon} />;
    } else if (genderName == "2") {
      return <img className="userIcon" src={femaleIcon} />;
    } else if (genderName == "3") {
      return <img className="userIcon" src={others} />;
    }
    return null;
  };

  return (
    <div>

      {calcWidth <= 767 ? (
        <div>
          {window.location.pathname === '/new/app/assessment-report' &&
            window.innerWidth < 500 &&
            window.matchMedia('(orientation: portrait)').matches && (
              <div className="card-container">
                <div className="card-content">
                  <h2>Rotate for better view</h2>
                  <span className="fa-stack fa-1x">
                    <i className="fas fa-mobile-alt fa-stack-2x"></i>
                    <i className="fas fa-mobile-alt fa-stack-2x fa-rotate-270 land"></i>
                    <i className="fas fa-reply fa-stack-1x fa-rotate-270"></i>
                  </span>
                </div>
              </div>
            )}


          <div
            className={`resp-NavBar ${window.location.pathname === '/new/app/assessment-report' ? 'assessment-report' : ''
              }`}
          >
            <Link to="/new/app/dashBoard">
              <img
                className="logo-img"
                src={opptimiseLogo}
                alt="Opptimise Logo"
              />
            </Link>
            <Popover
              positions={["bottom"]}
              align={"centre"}
              arrowStyle={{ left: "235px" }}
              targtElement={<img className="notification" src={notification} />}
              isOpen={props.enableNotification}
              setOpen={props.handleNotification}
            >
              <Notification
                successMessage={props.successMessage}
                respondentEmail={props.respondentEmail}
                updateMessage={props.updateMessage}
                notify={props.notify}
                handleCloseNotification={props.handleCloseNotification}
              />
            </Popover>
          </div>
        </div>
      ) : (
        <div className="NavBar">
          <Popover
            positions={["bottom"]}
            align={"centre"}
            arrowStyle={{ marginTop: "-3.7em" }}
            targtElement={<img className="notification" src={notification} />}
            isOpen={props.enableNotification}
            setOpen={props.handleNotification}
          >
            <Notification
              successMessage={props.successMessage}
              respondentEmail={props.respondentEmail}
              updateMessage={props.updateMessage}
              notify={props.notify}
              handleCloseNotification={props.handleCloseNotification}
            />
          </Popover>
          <UncontrolledDropdown>
            <DropdownToggle className="DropdownToggle">
              {handleGender()}
              <p className="Hello">Hello,</p>
              <p className="userName">
                {userName}!
                <i className="fa fa-chevron-down" aria-hidden="true" />
              </p>
            </DropdownToggle>
            <DropdownMenu right>
              <Link to="/new/app/editProfile">
                <DropdownItem className="DropdownItem">
                  <i className="fa fa-user" aria-hidden="true" />
                  <span>View/Edit Profile</span>
                </DropdownItem>
              </Link>
              <Link to="/change-password">
                <DropdownItem className="DropdownItem">
                  <i className="fas fa-key" />
                  <span>Change Password</span>
                </DropdownItem>
              </Link>
              <DropdownItem divider />
              <RouterLink to="/login">
                <DropdownItem className="DropdownItem">
                  <i className="fa fa-power-off" aria-hidden="true" />
                  <span
                    onClick={logout}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        logout();
                      }
                    }}
                    role="button"
                    tabIndex="0"
                  >
                    Logout
                  </span>
                </DropdownItem>
              </RouterLink>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      )}
    </div>
  );
};

NewNavBar.propTypes = {
  enableNotification: PropTypes.bool,
  handleNotification: PropTypes.func,
  successMessage: PropTypes.string,
  respondentEmail: PropTypes.string,
  updateMessage: PropTypes.func,
  notify: PropTypes.bool,
  handleCloseNotification: PropTypes.func
};


export default NewNavBar;



// WEBPACK FOOTER //
// ./src/new/Components/NavBar/Navbar.jsx